import styled from '@emotion/styled';
import React, { forwardRef, memo } from 'react';
import Spinner, { SpinnerSizes, SpinnerTypes, } from '@polestar/component-warehouse-react/components/spinner/Spinner';
import { m as motion } from 'framer-motion';
import { css } from '@emotion/react';
import { createTransition } from '@polestar/component-warehouse-react/tokens/motion/Motion';
const VideoPlayerBufferSkeleton = memo(forwardRef(({ buffering, playing, ...props }, ref) => {
    return (React.createElement(Wrapper, { ...props, ref: ref, animate: { opacity: buffering ? 1 : 0 }, transition: createTransition({ delay: buffering && playing ? 1 : 0 }) }, buffering && React.createElement(Spinner, { type: SpinnerTypes.inverted, size: SpinnerSizes.medium })));
}));
VideoPlayerBufferSkeleton.displayName = 'VideoPlayerBufferSkeleton';
export default VideoPlayerBufferSkeleton;
const Wrapper = styled(motion.div)(({ theme }) => css `
    overflow: hidden;
    width: 100%;
    height: 100%;
    z-index: 2;
    position: absolute;
    pointer-events: none;

    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.videoPlayer.skeleton.backgroundColor};
  `);
